import React from "react";
import { Steps } from "antd";

interface ConsultorProgressStepsProps {
  activeStep: number;
}

export function ConsultorProgressSteps({ activeStep }: ConsultorProgressStepsProps) {
  const items = [
    { title: "Informações Básicas" },
    { title: "Hierarquia" },
    { title: "Configurações" },
  ];

  return (
    <div style={{ marginBottom: '32px' }}>
      <Steps
        current={activeStep - 1}
        items={items}
        size="small"
      />
    </div>
  );
}